import { render, staticRenderFns } from "./SizedBox.vue?vue&type=template&id=15b58577&scoped=true&"
import script from "./SizedBox.ts?vue&type=script&lang=ts&"
export * from "./SizedBox.ts?vue&type=script&lang=ts&"
import style0 from "./SizedBox.vue?vue&type=style&index=0&id=15b58577&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b58577",
  null
  
)

export default component.exports